import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../App.css'; // Add your styling if needed
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  p {
    font-size: 16px;
    text-align: left;
    margin-left: 10px;
  }
`;

function SettingsPage() {
    let [fontSize, setFontSize] = useState(16);
    let [iconSize, setIconSize] = useState(100);
    let [gridStep, setGridStep] = useState(25);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { workspaceName } = useParams(); 
    const [sharedMembers, setSharedMembers] = useState([]);
    const [newSharedEmail, setNewSharedEmail] = useState("");
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const navigate = useNavigate();

    async function fetchSharedMembers() {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${API_URL}/api/devices/workspace/${workspaceName}/sharedWith`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });
            if (response.ok) {
                const data = await response.json();
                // Ожидается, что сервер вернёт объект вида { sharedWith: [...] }
                setSharedMembers(data.sharedWith);
            } else {
                console.error("Ошибка загрузки списка доступа");
            }
        } catch (error) {
            console.error("Ошибка загрузки списка доступа:", error);
        }
    }

    // Функция для добавления нового пользователя в sharedWith
    async function handleAddSharedMember() {
        const token = localStorage.getItem('token');
        if (!newSharedEmail.trim()) {
            alert("Введите email нового пользователя");
            return;
        }
        try {
            //const response = await fetch(`${API_URL}/api/devices/workspace/${workspaceName}/items`, {
            const response = await fetch(`${API_URL}/api/devices/workspace/${workspaceName}/sharedWith`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ email: newSharedEmail }),
            });
            if (response.ok) {
                // После успешного добавления перезагружаем список
                fetchSharedMembers();
                setNewSharedEmail("");
            } else {
                console.error("Ошибка добавления доступа");
            }
        } catch (error) {
            console.error("Ошибка добавления доступа:", error);
        }
    }

    // Загружаем список sharedWith при монтировании компонента
    useEffect(() => {
        fetchSharedMembers();
    }, []);

    useEffect(() => {
        const fetchWorkspaceSettings = async () => {
            try {
                const token = localStorage.getItem('token');

                if (!token) throw new Error('No token found, user is not authenticated');
                const response = await fetch(`${API_URL}/api/devices/workspace/${workspaceName}/settings`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`, // Attach the token
                    },
                });
                if (!response.ok) throw new Error('Failed to load workspace');
                const data = await response.json();
                                
                if (data) {
                    setFontSize(data.settings.fontSize ?? 14);
                    setIconSize(data.settings.iconSize ?? 100);
                    setGridStep(data.settings.gridStep ?? 25);
                }

                setLoading(false);
            } catch (err) {
                console.error(err);
                setError(err.message);
                setLoading(false);
            }
        };
        fetchWorkspaceSettings();
    }, []);

    const handleSave = async () => {
        try {// Send updated settings to backend API
            const token = localStorage.getItem('token'); // Retrieve the token from localStorage
            if (!token) {
                console.error('Token not found in localStorage');
                return;
            }

            const response = await fetch(`${API_URL}/api/devices/workspace/${workspaceName}/settings`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ fontSize, iconSize, gridStep }),
            });

            if (response.ok) {//if (url.includes("workspace/settings")) {
                    //navigate('/device-manager-test', { state: { fontSize, iconSize, gridStep } });
                    navigate('/device-manager', { state: { fontSize, iconSize, gridStep } });
            } else {
                console.error('Failed to save settings');
            }
        } catch (error) {
            console.error('Error occurred while saving settings:', error);
        }
    };

    const returnDefaults = async () => {
        try {
            document.getElementById("fontSize").value = 16;
            document.getElementById("iconSize").value = 100;
            document.getElementById("gridStep").value = 25;
            fontSize = 16;
            iconSize = 100;
            gridStep = 25;
            setFontSize(fontSize ?? 14);
            setIconSize(iconSize ?? 100);
            setGridStep(gridStep ?? 25);

        } catch (error) {
            console.error('Error occurred while saving settings:', error);
        }
    };

    if (loading) return <div>Loading settings...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div>
            <h1>Настройки</h1>
            <div>
                <label>Размер шрифта, px: </label>
                <input id="fontSize"
                    type="number"
                    value={fontSize} 
                    onChange={(e) => setFontSize(Number(e.target.value))}
                />
            </div>
            <div>
                <label>Icon Size, pt : </label>
                <input id="iconSize" 
                    type="number"
                    value={iconSize}
                    onChange={(e) => setIconSize(Number(e.target.value))}
                />
            </div>
            <div>
                <label>Grid Step, pt: </label>
                <input id="gridStep"
                    type="number"
                    value={gridStep}
                    onChange={(e) => setGridStep(Number(e.target.value))}
                />
            </div>
            <div
                style={{
                    position: 'fixed', left: '0', bottom: '0', width: '100%', display: 'flex',
                    flexDirection: 'row', // Horizontal layout
                    justifyContent: 'space-around', // Evenly spaced buttons
                    padding: '10px', paddingBottom: `calc(40px + env(safe-area-inset-bottom))`, // Adjust for safe area inset
                    backgroundColor: '#f9f9f9', // Light background for better contrast
                    borderTop: '1px solid #ddd', // Subtle border at the top
                    boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)', // Shadow for a modern look
                    zIndex: 11, // Stay above other content
                }}
            >
            <button onClick={handleSave}
                style={{
                    flex: '1', margin: '0 5px', padding: '12px 15px', fontSize: '16px', fontWeight: 'bold', color: '#fff',
                    backgroundColor: '#28a745', border: 'none', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    cursor: 'pointer', transition: 'background-color 0.3s ease',
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = '#218838')} // Darker green on hover
                onMouseOut={(e) => (e.target.style.backgroundColor = '#28a745')} // Revert on mouse out
            >
                Сохранить и вернуться
            </button>
                <button onClick={returnDefaults}
                style={{
                    flex: '1', margin: '0 5px', padding: '12px 15px', fontSize: '16px', fontWeight: 'bold',
                    color: '#fff', backgroundColor: '#ac757d', border: 'none', borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', cursor: 'pointer', transition: 'background-color 0.3s ease',
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = '#218838')} // Darker green on hover
                onMouseOut={(e) => (e.target.style.backgroundColor = '#28a745')} // Revert on mouse out
            >
                Вернуть значения по умолчанию
                </button>
            </div>


            {/* ------------------ Секция управления доступом (sharedWith) ------------------ */}
            <div style={{ marginTop: "30px", borderTop: "1px solid #ccc", paddingTop: "20px" }}>
                <h2>Управление доступом для членов семьи</h2>
                <p>Список пользователей, которым предоставлен доступ:</p>
                {sharedMembers && sharedMembers.length > 0 ? (
                    <ul>
                        {sharedMembers.map(member => (
                            <li key={member._id || member}>{member.email || member}</li>
                        ))}
                    </ul>
                ) : (
                    <p>Доступ пока не предоставлен.</p>
                )}
                <div style={{ marginTop: "10px" }}>
                    <input
                        type="text"
                        placeholder="Email нового пользователя"
                        value={newSharedEmail}
                        onChange={(e) => setNewSharedEmail(e.target.value)}
                    />
                    <button onClick={handleAddSharedMember} style={{ marginLeft: "10px" }}>
                        Добавить доступ
                    </button>
                </div>
            </div>

        </div>
    );
}

export default SettingsPage;
